
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TabBar from '../../components/layout/TabBar';

const currentOrders = [
  {
    id: 1,
    service: 'تمريض منزلي',
    technician: 'أحمد محمد',
    date: '15 يناير 2024',
    time: '11:00 ص',
    status: 'جاري التوجه',
    statusColor: 'text-[#FBC02D]',
    icon: 'ri-nurse-line',
    color: 'from-[#1565C0] to-[#1976D2]',
    price: '200'
  },
  {
    id: 2,
    service: 'صيانة مكيفات',
    technician: 'خالد العتيبي',
    date: '16 يناير 2024',
    time: '15:00 م',
    status: 'قيد الانتظار',
    statusColor: 'text-[#F57C00]',
    icon: 'ri-temp-cold-line',
    color: 'from-[#00838F] to-[#0097A7]',
    price: '200'
  }
];

const previousOrders = [
  {
    id: 3,
    service: 'تنظيف شامل',
    technician: 'محمد السالم',
    date: '10 يناير 2024',
    time: '09:00 ص',
    status: 'مكتمل',
    statusColor: 'text-[#2E7D32]',
    icon: 'ri-brush-line',
    color: 'from-[#2E7D32] to-[#43A047]',
    price: '150',
    rating: 5
  },
  {
    id: 4,
    service: 'سباكة',
    technician: 'عبدالله الشمري',
    date: '5 يناير 2024',
    time: '13:00 م',
    status: 'مكتمل',
    statusColor: 'text-[#2E7D32]',
    icon: 'ri-drop-line',
    color: 'from-[#0277BD] to-[#0288D1]',
    price: '180',
    rating: 4
  },
  {
    id: 5,
    service: 'كهرباء',
    technician: 'أحمد محمد',
    date: '1 يناير 2024',
    time: '17:00 م',
    status: 'مكتمل',
    statusColor: 'text-[#2E7D32]',
    icon: 'ri-flashlight-line',
    color: 'from-[#F57C00] to-[#FB8C00]',
    price: '160',
    rating: 5
  }
];

export default function Orders() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<'current' | 'previous'>('current');

  return (
    <div className="min-h-screen bg-[#F6F6F6] pb-20">
      {/* Header */}
      <div className="bg-gradient-to-br from-[#1565C0] to-[#2E7D32] pt-12 pb-6 px-6 rounded-b-[30px]">
        <h1 className="text-2xl font-bold text-white mb-4 animate-fadeIn">طلباتي</h1>
        
        {/* Tabs */}
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-1 flex gap-1 animate-slideUp">
          <button
            onClick={() => setActiveTab('current')}
            className={`flex-1 py-2.5 rounded-xl font-semibold text-sm transition-all ${
              activeTab === 'current'
                ? 'bg-white text-[#1565C0] shadow-md'
                : 'text-white/80'
            }`}
          >
            الطلبات الحالية ({currentOrders.length})
          </button>
          <button
            onClick={() => setActiveTab('previous')}
            className={`flex-1 py-2.5 rounded-xl font-semibold text-sm transition-all ${
              activeTab === 'previous'
                ? 'bg-white text-[#1565C0] shadow-md'
                : 'text-white/80'
            }`}
          >
            الطلبات السابقة ({previousOrders.length})
          </button>
        </div>
      </div>

      {/* Orders List */}
      <div className="px-6 mt-6 pb-4">
        {activeTab === 'current' ? (
          <div className="space-y-4">
            {currentOrders.map((order, index) => (
              <div
                key={order.id}
                onClick={() => navigate('/order-tracking')}
                className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-lg transition-all active:scale-[0.98] animate-slideUp cursor-pointer"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="p-4">
                  <div className="flex items-start gap-3 mb-3">
                    <div className={`w-12 h-12 bg-gradient-to-br ${order.color} rounded-xl flex items-center justify-center flex-shrink-0`}>
                      <i className={`${order.icon} text-white text-xl`}></i>
                    </div>
                    <div className="flex-1">
                      <h3 className="font-bold text-[#212121] mb-1">{order.service}</h3>
                      <p className="text-sm text-gray-600 mb-2">الفني: {order.technician}</p>
                      <div className="flex items-center gap-3 text-xs text-gray-500">
                        <span className="flex items-center gap-1">
                          <i className="ri-calendar-line"></i>
                          {order.date}
                        </span>
                        <span className="flex items-center gap-1">
                          <i className="ri-time-line"></i>
                          {order.time}
                        </span>
                      </div>
                    </div>
                    <div className="text-left">
                      <div className="flex items-center gap-1 mb-1">
                        <span className="text-lg font-bold text-[#1565C0]">{order.price}</span>
                        <span className="text-xs text-gray-400">ر.س</span>
                      </div>
                    </div>
                  </div>

                  <div className="flex items-center justify-between pt-3 border-t border-gray-100">
                    <span className={`text-sm font-semibold ${order.statusColor} flex items-center gap-1`}>
                      <div className="w-2 h-2 rounded-full bg-current animate-pulse"></div>
                      {order.status}
                    </span>
                    <button className="text-[#1565C0] text-sm font-semibold flex items-center gap-1">
                      تتبع الطلب
                      <i className="ri-arrow-left-line"></i>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="space-y-4">
            {previousOrders.map((order, index) => (
              <div
                key={order.id}
                className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-lg transition-all active:scale-[0.98] animate-slideUp"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="p-4">
                  <div className="flex items-start gap-3 mb-3">
                    <div className={`w-12 h-12 bg-gradient-to-br ${order.color} rounded-xl flex items-center justify-center flex-shrink-0`}>
                      <i className={`${order.icon} text-white text-xl`}></i>
                    </div>
                    <div className="flex-1">
                      <h3 className="font-bold text-[#212121] mb-1">{order.service}</h3>
                      <p className="text-sm text-gray-600 mb-2">الفني: {order.technician}</p>
                      <div className="flex items-center gap-3 text-xs text-gray-500">
                        <span className="flex items-center gap-1">
                          <i className="ri-calendar-line"></i>
                          {order.date}
                        </span>
                        <span className="flex items-center gap-1">
                          <i className="ri-time-line"></i>
                          {order.time}
                        </span>
                      </div>
                    </div>
                    <div className="text-left">
                      <div className="flex items-center gap-1 mb-1">
                        <span className="text-lg font-bold text-[#1565C0]">{order.price}</span>
                        <span className="text-xs text-gray-400">ر.س</span>
                      </div>
                    </div>
                  </div>

                  <div className="flex items-center justify-between pt-3 border-t border-gray-100">
                    <div className="flex items-center gap-1">
                      {[...Array(5)].map((_, i) => (
                        <i
                          key={i}
                          className={`${
                            i < order.rating! ? 'ri-star-fill text-[#FBC02D]' : 'ri-star-line text-gray-300'
                          } text-sm`}
                        ></i>
                      ))}
                    </div>
                    <button
                      onClick={() => navigate(`/service/${order.id}`)}
                      className="text-[#1565C0] text-sm font-semibold"
                    >
                      إعادة الطلب
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <TabBar />
    </div>
  );
}
